module.exports = __webpack_public_path__ + "img/Currys--Gift-Card-Design.a46abe0e.png";